var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _rect, _polygon31, _polygon32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoalerBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.7 18.8 15.1 17.8 15.7 18.1 15.4 19 14.7 18.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.1 20.2 14.5 19.3 15.2 19.5 14.8 20.5 14.1 20.2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.6 21.5 13.9 20.6 14.6 21 14.3 21.9 13.6 21.5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13 23 13.3 22 14 22.3 13.7 23.2 13 23"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.4 24.4 12.8 23.5 13.5 23.7 13.1 24.7 12.4 24.4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.9 25.8 12.2 24.8 12.9 25.2 12.6 26.1 11.9 25.8"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.3 27.2 11.6 26.3 12.3 26.5 12 27.4 11.3 27.2"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.7 28.6 11.1 27.7 11.8 28 11.4 28.9 10.7 28.6"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.2 29.9 10.5 29 11.2 29.4 10.9 30.3 10.2 29.9"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.6 31.4 9.9 30.5 10.6 30.7 10.3 31.6 9.6 31.4"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.5 18.8 24.1 17.8 23.5 18.1 23.9 19 24.5 18.8"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25 20.2 24.7 19.3 24 19.6 24.5 20.5 25 20.2"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.6 21.6 25.3 20.6 24.6 21 25 21.9 25.6 21.6"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.2 23 25.8 22.1 25.2 22.3 25.6 23.3 26.2 23"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.7 24.5 26.4 23.5 25.7 23.8 26.2 24.7 26.7 24.5"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.4 25.8 27 24.9 26.3 25.2 26.7 26.2 27.4 25.8"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28 27.3 27.5 26.3 26.9 26.6 27.3 27.5 28 27.3"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.6 28.7 28.1 27.8 27.5 28 27.9 29 28.6 28.7"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.1 30.2 28.7 29.1 28.1 29.5 28.4 30.4 29.1 30.2"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.7 31.5 29.2 30.6 28.7 30.8 29 31.9 29.7 31.5"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.3 19 19.3 18 19.9 18 19.9 19 19.3 19"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.3 20.4 19.3 19.5 19.9 19.5 19.9 20.4 19.3 20.4"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.3 21.9 19.3 21 19.9 21 19.9 21.9 19.3 21.9"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.3 23.3 19.3 22.3 19.9 22.3 20 23.3 19.3 23.3"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.4 24.7 19.3 23.8 20 23.8 20 24.7 19.4 24.7"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.4 26.2 19.4 25.3 20 25.3 20 26.2 19.4 26.2"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.4 27.7 19.4 26.6 20 26.6 20 27.7 19.4 27.7"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.4 29 19.4 28.1 20 28.1 20 29 19.4 29"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.4 30.5 19.4 29.5 20 29.5 20 30.5 19.4 30.5"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.4 32 19.4 30.9 20 30.9 20 32 19.4 32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.6,
    y: 5.6,
    width: 12.3,
    height: 11
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.6 16.5 12.6 5.6 3.1 10.2 3.1 30.2 12.6 16.5"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.7 16.5 26.7 5.6 36.2 10.2 36.2 30.2 26.7 16.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoalerBed);
export default __webpack_public_path__ + "static/media/roaler-bed.4b9907a92bcaee10ef4820f0307ad4b1.svg";
export { ForwardRef as ReactComponent };